<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0">
      <el-col :span="5">
        <el-form-item label="房产" prop="propertyId">
          <el-select
            :value="propertyName"
            ref="propertySelectRef"
            placeholder="请选择房产"
            style="width: 100%;"
            clearable
            @clear="clearProperty"
          >
            <el-option :value="propertyName" :label="propertyName">
              <el-tree
                ref="propertyTreeRef"
                node-key="id"
                :props="treeProps"
                :load="lazyLoadPropertyTree"
                lazy
                @node-click="propertyNodeTreeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="收费单号" prop="paybillNo">
          <el-input v-model="query.paybillNo" placeholder="根据收费单号查询"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="退费单号" prop="paybillNo">
          <el-input v-model="query.returnbillNo" placeholder="根据退费单号查询"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item label="退款状态">
          <el-select v-model="query.payStatus" style="width: 100%;" clearable>
            <el-option
              style="padding-left: 10px;"
              v-for="item in returnApplyList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="申请日期 从">
          <el-date-picker
            v-model="query.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="4" offset="1">
        <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
        <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openReturnDetailsForm('view', scope.row)"
          >退款详情</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-check"
          v-if="showAuditBtn()"
          @click="openReturnAuditForm(scope.row)"
          >审核</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      :title="returnDetailForm.title"
      :visible.sync="returnDetailForm.show"
      v-if="returnDetailForm.show"
      :modal-append-to-body="false"
      width="60%"
    >
      <!-- 使用组件 -->
      <return-detail-form
        :operateType="returnDetailForm.operateType"
        :rowData="returnDetailForm.rowData"
        @closeReturnDetailForm="closeReturnDetailForm"
      ></return-detail-form>
      <router-link to=""></router-link>
    </el-dialog>
    <fee-return-audit-dialog
      ref="feeReturnAuditDialog"
      @closeAuditForm="refreshChange"
    ></fee-return-audit-dialog>
  </basic-container>
</template>

<script>
import { getFeeReturnList } from '@/api/v4ward/feereturn/feereturn';
import { mapGetters } from 'vuex';
import { getDictionaryWithIntKey } from '../../../api/common';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
import feeReturnAuditDialog from '@/views/v4ward/feereturn/feereturn-audit';
import returnDetailForm from '@/views/v4ward/feereturn/feereturn-details';

export default {
  components: {
    feeReturnAuditDialog,
    returnDetailForm,
  },
  data() {
    return {
      treeProps: {
        //标题
        label: 'objectFullName',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      propertyName: '',
      loading: true,
      data: [],
      returnDetailForm: {
        show: false,
        title: '',
        operateType: '',
        rowData: '',
      },
      selectionList: [],
      returnApplyList: [],
      option: {
        height: 'auto',
        calcHeight: 80,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        indexLabel: '序号',
        selection: false,
        labelWidth: 100,
        menuWidth: 220,
        align: 'center',
        column: [
          {
            label: '收费主表ID',
            prop: 'feePayId',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入收费主表ID',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'commName',
            width: 130,
          },
          {
            label: '房间名称',
            prop: 'roomName',
            width: 180,
            overHidden: true,
          },
          {
            label: '收费单号',
            prop: 'paybillNo',
            hide: true,
            width: 176,
          },
          {
            label: '付款金额',
            width: 80,
            prop: 'totalPayAmount',
            rules: [
              {
                required: true,
                message: '请输入实收总金额',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '退费单号',
            prop: 'returnbillNo',
            width: 168,
            rules: [
              {
                required: true,
                message: '请输入退费单号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '退款结算单号',
            prop: 'returnbalanceNo',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入退款结算单号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '实退金额1',
            prop: 'return1Amount',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入实退金额1',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '实退金额2',
            prop: 'return2Amount',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入实退金额2',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '实退金额3',
            prop: 'return3Amount',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入实退金额3',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '实退金额4',
            prop: 'return4Amount',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入实退金额4',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '退款总额',
            prop: 'totalReturnAmount',
            width: 80,
            rules: [
              {
                required: true,
                message: '请输入实退总额',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '申请日期',
            prop: 'applyTime',
            type: 'date',
            width: 100,
            format: 'yyyy-MM-dd',
          },
          {
            label: '申请人',
            width: 70,
            prop: 'applyEmpName',
          },
          {
            label: '退款时间',
            prop: 'returnTime',
            width: 100,
            type: 'date',
            format: 'MM-dd HH:mm',
          },
          {
            label: '审批人',
            width: 70,
            prop: 'auditEmpName',
          },
          {
            label: '退款渠道',
            prop: 'returnChannel',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=return_channel',
          },
          {
            label: '退款状态',
            prop: 'returnStatus',
            width: 90,
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=return_apply',
          },
          {
            label: '退款理由',
            prop: 'returnRemark',
            overHidden: true,
            hide: true,
          },
          {
            label: '审批意见',
            prop: 'auditStatus',
            width: 80,
            props: {
              label: 'value',
              value: 'key',
            },
            dicData: [
              { key: 1, value: '同意' },
              { key: 2, value: '拒绝' },
              { key: -1, value: '待审批' },
            ],
          },
          {
            label: '审批说明',
            prop: 'auditRemark',
            hide: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feepay_add, false),
        viewBtn: this.vaildData(this.permission.feepay_view, false),
        delBtn: this.vaildData(this.permission.feepay_delete, false),
        editBtn: this.vaildData(this.permission.feepay_edit, false),
      };
    },
  },
  created() {},
  mounted() {
    this.initAllSelectionList();
  },
  methods: {
    showAuditBtn() {
      return this.vaildData(this.permission.feereturn_audit, false);
    },
    initAllSelectionList() {
      getDictionaryWithIntKey('return_apply').then((data) => {
        this.returnApplyList = data.data;
      });
    },
    ///////////////  退费查询页
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      getTreeChildrenPowerNode({ id: id, power: 1 }).then(({ data }) => {
        resolve(data);
      });
    },
    propertyNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];
      this.propertyName = nodeTitle;
      this.query.propertyId = nodeId;
      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
      }
    },
    searchReset() {
      this.query = {};
      this.propertyName = '';
      this.onLoad(this.page);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      if (params.dateRange) {
        params.dateFrom = params.dateRange[0] + ' 00:00:00.000';
        params.dateTo = params.dateRange[1] + ' 23:59:59.999';
      } else {
        delete params.dateFrom;
        delete params.dateTo;
      }
      page = page || this.page;
      getFeeReturnList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(
        (res) => {
          const data = res.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    closeReturnDetailForm(from) {
      this.returnDetailForm.show = false;
    },
    openReturnDetailsForm(type, row) {
      this.returnDetailForm.title = '退费详情查看';
      this.returnDetailForm.rowData = row;
      this.returnDetailForm.operateType = type;
      this.returnDetailForm.show = true;
    },
    openReturnAuditForm(row) {
      if (row.returnStatus !== 1) {
        this.$message.warning('状态必须为申请中才能审核！');
        return;
      }
      this.$refs.feeReturnAuditDialog.openDialogForm('退款审核', row.id);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange(val) {
      this.onLoad(this.page, this.query);
    },
    clearProperty() {
      this.propertyName = '';
      this.query.propertyId = '';
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding-left: 10px;
  line-height: 25px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-property-dialog-div {
  height: 500px;
  overflow: auto;
}
.el-card__body {
  padding: 10px !important;
}
</style>
